import PeriodicalStatus from "components/layout-components/Dashboard/PeriodicalStatus";
import CertificateOverview from "components/layout-components/Dashboard/CertificateOverview";
import CleaningAuditChart from "components/layout-components/Dashboard/CleaningAuditChart";
import StaffDetailsChart from "components/layout-components/Dashboard/StaffDetailsChart";
import EquipmentOverview from "components/layout-components/Dashboard/EquipmentOverview";
import EducationAndTrainingOverview from "components/layout-components/Dashboard/EducationAndTrainingOverview";
import { isDashboardManager } from "components/layout-components/Dashboard/managerScope";
import Icon, { EyeOutlined, RightOutlined } from "@ant-design/icons";
import { useState } from "react";
import moment from "moment";
import { getPreSignedUrl } from "utils/MyMUtils";
import { Modal, Popover, Table } from "antd";

const Dashboard = () => {

    const [showModalState, setShowModalState] = useState({
        expiredCerificateData: [],
        isExpiredCertificateModal: false,
        hasNoUsername: false,
        isIso: false,
        isShowModal: false,
        hasDescription: false,
        modalTitle: "",
        sortedInfo: null,
    })
    const [sortedInfo, setSortedInfo] = useState(null)
    // Certificates are client-wide (group/state certificates), so a manager,
    // who sees only their own facilities, does not get that card.
    const isManager = isDashboardManager()

    const handleTableChange = (pagination, filters, sorter) => {
        console.log("🚀 ~ DashBoardCharts ~ sorter:", sorter);
        setSortedInfo(sorter)
    };

    const showMoreFacility = (data) => {
        // Some rows come back without a facility; show them blank instead of crashing.
        const separateFacility = (data || "").split(",");

        const content =
            separateFacility.length > 1 ? (
                <ul className="show_more_facility_container">
                    {separateFacility.map((facility, index) => (
                        <li key={index} className="show_more_facility">
                            {facility}
                        </li>
                    ))}
                </ul>
            ) : (
                ""
            );
        return (
            <div>
                {" "}
                {separateFacility[0]}{" "}
                {separateFacility.length > 1 ? (
                    <Popover content={content} trigger="click">
                        ... <span className="view_more">View More</span>
                    </Popover>
                ) : (
                    ""
                )}{" "}
            </div>
        );
    };

    const expiredCerificateColumns = () => {
        if (showModalState?.hasNoUsername) {
            return [
                {
                    title: "State",
                    dataIndex: "state_name",
                    key: "state_name",
                    sorter: (a, b) =>
                        sortedInfo
                            ? (a.state_name || "").localeCompare(b.state_name || "")
                            : null,
                    sortOrder:
                        sortedInfo &&
                            sortedInfo.columnKey === "state_name"
                            ? sortedInfo.order
                            : null,
                },
                {
                    title: "Expiry Date",
                    dataIndex: "expiry_date",
                    key: "expiry_date",
                    // render: (_, data) => moment(data.expiry_date).format("DD-MM-YYYY"),
                },
                {
                    title: "",
                    dataIndex: "action",
                    key: "action",
                    render: (_, data) => (
                        <div onClick={() => getPreSignedUrl(data.pdf_link)}>
                            <EyeOutlined style={{ cursor: "pointer" }} />
                        </div>
                    ),
                },
            ];
        } else if (showModalState?.isIso) {
            return [
                {
                    title: "Name",
                    dataIndex: "name",
                    key: "name",
                    sorter: (a, b) =>
                        sortedInfo ? (a.name || "").localeCompare(b.name || "") : null,
                    sortOrder:
                        sortedInfo && sortedInfo.columnKey === "name"
                            ? sortedInfo.order
                            : null,
                },
                {
                    title: "Expiry Date",
                    dataIndex: "expiry_date",
                    key: "expiry_date",
                    // render: (_, data) => moment(data.expiry_date).format("DD-MM-YYYY"),
                },
                {
                    title: "",
                    dataIndex: "action",
                    key: "action",
                    render: (_, data) => (
                        <div onClick={() => getPreSignedUrl(data.pdf_link)}>
                            <EyeOutlined style={{ cursor: "pointer" }} />
                        </div>
                    ),
                },
            ];
        } else if (showModalState?.hasDescription) {
            return [
                {
                    title: "Description",
                    dataIndex: "name",
                    key: "name",
                    sorter: (a, b) =>
                        sortedInfo ? (a.name || "").localeCompare(b.name || "") : null,
                    sortOrder:
                        sortedInfo && sortedInfo.columnKey === "name"
                            ? sortedInfo.order
                            : null,
                },
                {
                    title: "Expiry Date",
                    dataIndex: "expiry_date",
                    key: "expiry_date",
                    // render: (_, data) => moment(data.expiry_date).format("DD-MM-YYYY"),
                },
                {
                    title: "",
                    dataIndex: "action",
                    key: "action",
                    render: (_, data) => (
                        <div onClick={() => getPreSignedUrl(data.pdf_link)}>
                            <EyeOutlined style={{ cursor: "pointer" }} />
                        </div>
                    ),
                },
            ];
        } else {
            return [
                {
                    title: "Staff Name",
                    dataIndex: "name",
                    key: "name",
                    sorter: (a, b) =>
                        sortedInfo ? (a.name || "").localeCompare(b.name || "") : null,
                    sortOrder:
                        sortedInfo && sortedInfo.columnKey === "name"
                            ? sortedInfo.order
                            : null,
                },
                {
                    title: "Facility",
                    dataIndex: "facility_name",
                    key: "facility_name",
                    render: (_, data) => showMoreFacility(data.facility_name),
                    sorter: (a, b) =>
                        sortedInfo
                            ? (a.facility_name || "").localeCompare(b.facility_name || "")
                            : null,
                    sortOrder:
                        sortedInfo &&
                            sortedInfo.columnKey === "facility_name"
                            ? sortedInfo.order
                            : null,
                },
                {
                    title: "Expiry Date",
                    dataIndex: "expiry_date",
                    key: "expiry_date",
                    // render: (_, data) => moment(data.expiry_date).format("DD/MM/YYYY"),
                    sorter: (a, b) =>
                        sortedInfo
                            ? moment(a.expiry_date, "DD-MM-YYYY").unix() -
                            moment(b.expiry_date, "DD-MM-YYYY").unix()
                            : null,
                    sortOrder:
                        sortedInfo &&
                            sortedInfo.columnKey === "expiry_date"
                            ? sortedInfo.order
                            : null,
                },
                {
                    title: "",
                    dataIndex: "action",
                    key: "action",
                    render: (_, data) => (
                        <div onClick={() => getPreSignedUrl(data.pdf_link)}>
                            <EyeOutlined style={{ cursor: "pointer" }} />
                        </div>
                    ),
                },
            ];
        }
    };

    const expiredEquipmentOverviewColumns = [
        {
            title: "Facility",
            dataIndex: "facility_name",
            key: "facility_name",
            width: "40%",
            render: (_, data) => data.other_details?.facility_name,
            sorter: (a, b) =>
                sortedInfo
                    ? (a.other_details?.facility_name || "").localeCompare(b.other_details?.facility_name || "")
                    : null,
        },
        {
            title: "Equipment",
            dataIndex: "equipment",
            key: "equipment",
            sorter: (a, b) =>
                sortedInfo ? (a.equipment || "").localeCompare(b.equipment || "") : null,
        },
        {
            title: "Test Tag Date",
            dataIndex: "test_tag_date",
            key: "test_tag_date",
            width: "20%",
            sorter: (a, b) =>
                sortedInfo
                    ? moment(a.test_tag_date, "DD-MM-YYYY").unix() -
                    moment(b.test_tag_date, "DD-MM-YYYY").unix()
                    : null,
        },
        {
            title: "Expiry Date",
            dataIndex: "expiry_date",
            key: "expiry_date",
            width: "20%",
            sorter: (a, b) =>
                sortedInfo
                    ? moment(a.expiry_date, "DD-MM-YYYY").unix() -
                    moment(b.expiry_date, "DD-MM-YYYY").unix()
                    : null,
        },
    ];

    const closeExpiredCerificateModal = () => {
        setShowModalState({
            expiredCerificateData: [],
            isExpiredCertificateModal: false,
            hasNoUsername: false,
            isIso: false,
            isShowModal: false,
            hasDescription: false,
            modalTitle: "",
            sortedInfo: null,
        });
    }

    return (
        <div className="dashboard-container">
            {/* First Row - 4 Cards */}
            <div className="audit-row">
                <div className="card">
                    <PeriodicalStatus />
                </div>
                <div className="card">
                    <CleaningAuditChart />
                </div>
                <div className="card">
                    <CleaningAuditChart isLaundry />
                </div>
                <div className="card">
                    <StaffDetailsChart />
                </div>
            </div>

            {/* Second Row - 3 Cards */}
            <div className={isManager ? "bottom-row bottom-row-two" : "bottom-row"}>
                <div className="card">
                    <EquipmentOverview showModalState={showModalState} setShowModalState={setShowModalState} />
                </div>
                {!isManager && (
                    <div className="card">
                        <CertificateOverview showModalState={showModalState} setShowModalState={setShowModalState} />
                    </div>
                )}
                <div className="card">
                    <EducationAndTrainingOverview />
                </div>
            </div>

            <Modal
                title={showModalState.modalTitle}
                visible={showModalState.isShowModal}
                footer={false}
                onCancel={() => closeExpiredCerificateModal()}
                width={800}
            >
                <Table
                    columns={
                        showModalState.isExpiredCertificateModal
                            ? expiredCerificateColumns()
                            : expiredEquipmentOverviewColumns
                    }
                    dataSource={showModalState.expiredCerificateData}
                    pagination={
                        showModalState.expiredCerificateData.length > 10 ? true : false
                    }
                    onChange={(pagination, filters, sorter) => {
                        handleTableChange(pagination, filters, sorter);
                        // setTimeout(() => {
                        //     window.scrollTo({
                        //         top: 0,
                        //         behavior: "smooth",
                        //     });
                        // }, 100);
                    }}
                />
            </Modal>
        </div>
    );
};


export default Dashboard;